module.exports = __webpack_public_path__ + "8b498e2cd42a1654d9e804790dc3d762.svg";